import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { DateTime, Interval } from 'luxon';
import { GeneralService } from 'src/app/services/general/general.service';

@Component({
  selector: 'app-agenda-dialog',
  templateUrl: './agenda-dialog.component.html',
  styleUrls: ['./agenda-dialog.component.scss'],
})
export class AgendaDialogComponent implements OnInit {
  public title: string;
  public start: string;
  public end: string;
  public state: Number | undefined;
  public allowJoin: boolean = false;
  constructor(
    public dialogRef: MatDialogRef<AgendaDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    public general: GeneralService
  ) {
    this.title = this.data.type.replaceAll('_', '-');
    this.start = DateTime.fromISO(this.data.start).toFormat('HH:mm');
    this.end = DateTime.fromISO(this.data.end).toFormat('HH:mm');
    this.checkIfJoin();
  }

  ngOnInit(): void {}

  closeDialog() {
    this.dialogRef.close();
  }

  joinClass() {
    const id = this.getId(this.data.id);
    this.dialogRef.close();
    this.general.navigate(`class/${this.data.type}/${id}`);
  }

  getId(data: string) {
    return data
      .replace('single_class_', '')
      .replace('test_class', '')
      .replace('weekly_class_', '')
      .replace('group_class_', '');
  }

  checkIfJoin() {
    const start = DateTime.fromISO(this.data.start).toMillis();
    const end = DateTime.fromISO(this.data.end).toMillis();
    const now = DateTime.local().setZone('utc');
    if (start > now.plus({ hours: 5 }).toMillis()) {
      this.allowJoin = false;
      return;
    }

    if (now.toMillis() > end) {
      this.allowJoin = false;
    } else {
      this.allowJoin = true;
    }
  }
}
